

export default function Divider(){

    return (
        <div
            className="
                px-12
                sm:px-28
            "
        >
            <div
                className="
                    h-px
                    bg-home-text-grey/30
                    my-7
                "
            />
        </div>

    );

}